/*
 * Identidade de um integrante do grupo familiar (composicaoFamiliar), usada
 * para casar anexos, pendências e abas com o integrante certo mesmo quando o
 * back e o front descrevem o mesmo integrante de formas ligeiramente
 * diferentes: com id, só por CPF, ou só pela descrição e o parentesco.
 */
export const getMemberId = member => {
    if (member === null || member === undefined || member === '') return null;
    if (typeof member !== 'object') return String(member);

    const directId = member.id ?? member.idComposicaoFamiliar;
    if (directId !== null && directId !== undefined && directId !== '') {
        return String(directId);
    }

    if (member.composicaoFamiliar && member.composicaoFamiliar !== member) {
        return getMemberId(member.composicaoFamiliar);
    }

    return null;
};

const normalizeMemberText = value => value === null || value === undefined
    ? ''
    : String(value).trim().toLowerCase();

const getMemberParentKey = member => normalizeMemberText(
    member?.parentescoDesc
        || member?.grauParentesco?.id
        || member?.grauParentesco?.descricao
        || member?.grauParentesco
);

export const isSameMember = (a, b) => {
    if (!a || !b) return false;

    /*
     * Integrante novo (sem id) criado nesta sessão: toda vez que o useForm da
     * etapa Socioeconômico reinicializa, os valores são clonados — a mesma
     * pessoa vira um objeto novo a cada edição, então nem `===` nem o id
     * (inexistente) resolvem, e o CPF pode ter sido justamente o que o
     * candidato veio corrigir. `chaveLocal` é atribuída uma vez, na criação, e
     * sobrevive aos clones (o spread `...existing` do handleSaveMembro a
     * carrega adiante), por isso é comparada antes de tudo.
     */
    if (a.chaveLocal && b.chaveLocal) return a.chaveLocal === b.chaveLocal;

    const aId = getMemberId(a);
    const bId = getMemberId(b);
    if (aId && bId) return aId === bId;

    const aCpf = normalizeMemberText(a.cpf);
    const bCpf = normalizeMemberText(b.cpf);
    if (aCpf && bCpf) return aCpf === bCpf;

    const sameDescription = normalizeMemberText(a.descricao) === normalizeMemberText(b.descricao);
    const aParentKey = getMemberParentKey(a);
    const bParentKey = getMemberParentKey(b);

    return sameDescription && (!aParentKey || !bParentKey || aParentKey === bParentKey);
};

/*
 * Índice de `membro` em `lista`: primeiro por identidade (===, a mesma
 * instância que o merger do back reconhece), depois pela primeira posição em
 * que isSameMember reconhece o mesmo integrante. -1 quando não encontra ou
 * quando `membro` é falsy.
 */
export const encontrarIndiceMembro = (lista = [], membro) => {
    if (!membro) return -1;

    const porIdentidade = lista.indexOf(membro);
    if (porIdentidade !== -1) return porIdentidade;

    return lista.findIndex(item => isSameMember(item, membro));
};
